import { WithStyles, withStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import { Theme } from '@material-ui/core/styles/createTheme'
import React from 'react'

interface IMapActionBar extends WithStyles {
  children: React.ReactNode
  fitContent?: boolean
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      boxShadow: '0 0 0 2px rgba(0, 0, 0, 0.1)',
      borderRadius: 4,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      zIndex: theme.zIndex.drawer,
      margin: '5px',
      minWidth: 50,
      minHeight: 30,
      maxWidth: '300px',
      background: '#FFF',
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  })

const MapActionBar = (props: IMapActionBar) => {
  const { classes, children, fitContent } = props
  return (
    <div className={classes.root} style={fitContent ? { width: 'fit-content' } : {}}>
      <div className={classes.content}>{children}</div>
    </div>
  )
}

export default withStyles(styles)(MapActionBar)
